export default __webpack_public_path__ + "static/media/LogoTrilhas.d152d9cb.png";